import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const [active, setActive] = useState('hot');

  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-grid-line text-lg text-primary-500"></i>
          </div>
          <h2 className="text-lg md:text-xl font-heading text-foreground-900">分类浏览</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={() => setActive(cat.slug)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}